export const EDIT_CHARTCOLOR= "EDIT_CHARTCOLOR"
export const LIST_CHARTCOLOR = "LIST_CHARTCOLOR"

export const CHARTCOLOR_SUCCESS = "CHARTCOLOR_SUCCESS"
export const CHARTCOLOR_ERROR = "CHARTCOLOR_ERROR"
